var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebportalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 256 241",
    enableBackground: "new 0 0 256 241",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254,188V2H2v186h111v29H75v22h106v-22h-38v-29H254z M19,19h217v151H19L19,19z M180.021,70.553 c0,7.395-2.874,14.326-7.987,19.524l-15.467,15.467l0.254-1.31c1.141-6.297,0.423-12.72-2.071-18.594l-0.127-0.254l6.339-6.339 c2.282-2.282,3.508-5.24,3.508-8.452c0-3.212-1.268-6.212-3.508-8.452c-2.282-2.282-5.282-3.508-8.452-3.508 c-3.212,0-6.212,1.268-8.452,3.508l-20.961,20.961c-2.282,2.282-3.508,5.282-3.508,8.452c0,3.212,1.268,6.212,3.508,8.452 c1.521,1.521,3.465,2.62,5.62,3.127l0.718,0.169l-12.002,12.002l-0.296-0.169c-1.859-1.141-3.592-2.493-5.156-4.057 c-5.198-5.24-8.072-12.128-8.072-19.524c0-7.395,2.874-14.326,8.072-19.524l20.961-20.961c5.24-5.198,12.128-8.072,19.524-8.072 c7.353,0,14.284,2.874,19.482,8.072S180.021,63.2,180.021,70.553z M144.101,78.92c5.198,5.198,8.029,12.128,8.029,19.524 c0,7.395-2.874,14.326-8.072,19.524l-20.961,20.961C117.9,144.126,110.97,147,103.574,147c-7.395,0-14.326-2.874-19.524-8.072 c-5.198-5.24-8.072-12.128-8.072-19.524s2.874-14.326,8.072-19.524l15.467-15.467l-0.254,1.31 c-1.141,6.297-0.423,12.72,2.071,18.594l0.127,0.254l-6.339,6.339c-2.282,2.282-3.508,5.282-3.508,8.452 c0,3.212,1.268,6.212,3.508,8.452c2.282,2.282,5.282,3.508,8.452,3.508c3.212,0,6.212-1.268,8.452-3.508l20.961-20.961 c4.649-4.649,4.649-12.213,0-16.861c-1.521-1.521-3.465-2.62-5.62-3.127l-0.718-0.169l12.002-12.002l0.296,0.169 C140.805,76.004,142.537,77.399,144.101,78.92z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebportalIcon);
export default __webpack_public_path__ + "static/media/webportalIcon.5fdbd2537b999d65cd5390045e738968.svg";
export { ForwardRef as ReactComponent };